import { encodeODataParams, objectFromKeyCollection, processResponse } from '../utils'; // core filter params needed for the global nav settings

const BASE_FILTER = "endswith(Key,'.IsLicensed') or endswith(Key,'.AppName') or endswith(Key,'.IsInImplementation') or startswith(Key,'Suite.') or startswith(Key,'Portal.') or (startswith(Key,'CookiePolicyRevisionIsoDate'))";

const getTenantProductConfiguration = async (fetchGet, tenantConfigUrl, tenantConfigParams) => {
  const additionalFilters = tenantConfigParams?.trim?.();
  const filter = additionalFilters ? `(${BASE_FILTER}) or (${additionalFilters})` : BASE_FILTER;
  const params = {
    filter
  };
  const encodedFilter = encodeODataParams(params);
  const url = `${tenantConfigUrl}?${encodedFilter}`;
  const result = await fetchGet(url);
  const response = await processResponse(result);
  return {
    config: objectFromKeyCollection(response),
    raw: response
  };
};

export default getTenantProductConfiguration;
//# sourceMappingURL=getTenantProductConfiguration.js.map